import React, { useEffect } from 'react'
// import DriverSec1 from '../../Components/DriverSec1/page'
import CupTable from '../../Components/CupTable/page'
// import DriverSec3 from '../../Components/DriverSec3/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO CUP SERIES" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <CupTable/>

    </>
  )
}

export default Page